import { render, staticRenderFns } from "./CreationWizard.vue?vue&type=template&id=0c27bb70&scoped=true&"
import script from "./CreationWizard.vue?vue&type=script&lang=js&"
export * from "./CreationWizard.vue?vue&type=script&lang=js&"
import style0 from "./CreationWizard.vue?vue&type=style&index=0&id=0c27bb70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c27bb70",
  null
  
)

export default component.exports